/* Auto-generated from sk-collection-lovebrand-override.liquid */

  (function() {
    if (!document.body.classList.contains('template-collection')) return;
    function injectRatings() {
      var dataEl = document.getElementById('sk-col-ratings-data');
      if (!dataEl) return;
      var raw = (dataEl.textContent || '').trim();
      if (!raw || raw === '{}') return;
      // Clean trailing commas that Liquid's forloop.last sometimes leaves
      raw = raw.replace(/,\s*}/g, '}').replace(/,\s*\]/g, ']');
      var ratings;
      try { ratings = JSON.parse(raw); } catch(e) { console.warn('sk-col-ratings parse', e); return; }

      var items = document.querySelectorAll('.productgrid--item, .productitem');
      items.forEach(function(item) {
        if (item.querySelector('.sk-col-rating')) return;
        var link = item.querySelector('a[href*="/products/"]');
        if (!link) return;
        var m = link.href.match(/\/products\/([^?#\/]+)/);
        if (!m) return;
        var handle = m[1];
        var r = ratings[handle];
        if (!r || !r.total) return;

        var avg = parseFloat(r.avg) || 0;
        // Hide low ratings (< 3.5) or very few reviews (< 2) — avoids negative-signal display
        if (avg < 3.5 || r.total < 2) return;
        var stars = '';
        for (var i = 1; i <= 5; i++) {
          if (avg >= i) stars += '★';
          else if (avg >= i - 0.5) stars += '★';
          else stars += '☆';
        }
        var el = document.createElement('div');
        el.className = 'sk-col-rating';
        el.innerHTML = '<span class="sk-col-rating__stars" aria-hidden="true">' + stars + '</span>' +
                       '<span class="sk-col-rating__avg">' + avg.toFixed(1).replace('.',',') + '</span>' +
                       '<span class="sk-col-rating__total">· ' + r.total + ' Bewertungen</span>';

        var info = item.querySelector('.productitem--info');
        var price = item.querySelector('.productitem__price, [class*="price"]');
        if (price && price.parentElement) {
          price.parentElement.insertBefore(el, price);
        } else if (info) {
          info.appendChild(el);
        }
      });
    }
    function hideEmptyFilters() {
      // Hide filter list items where the visible label contains "(0)" — empty filter options
      var items = document.querySelectorAll('.collection-filters__filter-list-item, .productgrid--sidebar-item');
      items.forEach(function(li) {
        var txt = (li.textContent || '').trim();
        if (/\(\s*0\s*\)\s*$/.test(txt)) {
          li.style.display = 'none';
        }
      });
    }
    function setupDescToggle() {
      var desc = document.querySelector('.collection--description');
      if (!desc || desc.dataset.toggleReady) return;
      desc.dataset.toggleReady = '1';
      // Measure: only add toggle if content is actually clipped at 3 lines
      var collapsedH = desc.clientHeight;
      // Temporarily expand to compare
      desc.classList.add('is-expanded');
      var expandedH = desc.clientHeight;
      desc.classList.remove('is-expanded');
      if (expandedH - collapsedH < 8) return; // no real overflow → no toggle needed

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'collection--description-toggle is-visible';
      btn.textContent = 'Mehr lesen';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function() {
        var open = desc.classList.toggle('is-expanded');
        btn.textContent = open ? 'Weniger anzeigen' : 'Mehr lesen';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      desc.parentNode.insertBefore(btn, desc.nextSibling);
    }
    function init() {
      injectRatings();
      hideEmptyFilters();
      setupDescToggle();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    var grid = document.querySelector('.productgrid--items');
    if (grid && 'MutationObserver' in window) {
      var obs = new MutationObserver(function() { init(); });
      obs.observe(grid, { childList: true, subtree: true });
    }
    var sidebar = document.querySelector('.productgrid--sidebar');
    if (sidebar && 'MutationObserver' in window) {
      var obs2 = new MutationObserver(function() { hideEmptyFilters(); });
      obs2.observe(sidebar, { childList: true, subtree: true, characterData: true });
    }
  })();
